<template>
  <div
    class="tw-hidden md:tw-flex md:tw-w-1/2 lg:tw-w-2/3 tw-items-center tw-justify-center tw-fixed tw-right-0 tw-h-screen tw-rounded-l-4xl"
    :style="{ 'background-color': `rgb(${color})` }"
  >
    <div class="tw-w-3/5 tw-aspect-w-1 tw-aspect-h-1">
      <div
        class="login--background-image tw-bg-center tw-bg-contain"
        :style="{
          'background-image': `url(${background})`,
        }"
      ></div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import ColorThief from "colorthief";
import { ref } from "vue";

const props = withDefaults(
  defineProps<{
    background?: string;
  }>(),
  {
    background: "",
  }
);

const colorThief = new ColorThief();
const color = ref("255 255 255");

const image = new Image(220, 220);
image.crossOrigin = "Anonymous";
image.src = props.background;

if (image.complete) {
  color.value = colorThief.getColor(image);
} else {
  image.addEventListener("load", () => {
    color.value = colorThief.getColor(image);
  });
}
</script>
